/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionIssuer,
  UserSessionIssuer$inboundSchema,
} from "./usersessionissuer.js";

/**
 * What attaching a user_session_issuer to an existing MCP server changes for its clients.
 */
export type UserSessionIssuerAttachImpact = {
  /**
   * True when the authorization server the server advertises to clients changes: its own per-server authorization server, a shared authorization server's issuer URL, or none. Anything configured with the current authorization server, such as an identity provider or a federated platform, must be updated.
   */
  authorizationServerChanges: boolean;
  /**
   * A user_session_issuer record.
   */
  candidateIssuer?: UserSessionIssuer | undefined;
  /**
   * A user_session_issuer record.
   */
  currentIssuer?: UserSessionIssuer | undefined;
  /**
   * True when the server has an issuer and the change replaces or removes it. Its clients' registrations and sessions belong to the current issuer, so every client must register and authorize again.
   */
  reauthorizationRequired: boolean;
};

/** @internal */
export const UserSessionIssuerAttachImpact$inboundSchema: z.ZodMiniType<
  UserSessionIssuerAttachImpact,
  unknown
> = z.pipe(
  z.object({
    authorization_server_changes: z.boolean(),
    candidate_issuer: z.optional(UserSessionIssuer$inboundSchema),
    current_issuer: z.optional(UserSessionIssuer$inboundSchema),
    reauthorization_required: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "authorization_server_changes": "authorizationServerChanges",
      "candidate_issuer": "candidateIssuer",
      "current_issuer": "currentIssuer",
      "reauthorization_required": "reauthorizationRequired",
    });
  }),
);

export function userSessionIssuerAttachImpactFromJSON(
  jsonString: string,
): SafeParseResult<UserSessionIssuerAttachImpact, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UserSessionIssuerAttachImpact$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UserSessionIssuerAttachImpact' from JSON`,
  );
}
